moduleViewApp.service("HeaderRowParser", ['$rootScope', 'DebugHelper', 'FieldMapper', 'HeaderRowCompatibilityService', 'PartnerTagUploadService', ($rootScope, DebugHelper, FieldMapper, HeaderRowCompatibilityService, PartnerTagUploadService) ->
  (headerRow) ->
    $scope = $rootScope.$new()
    DebugHelper.register("HeaderRowParser", $scope)

    _.assignIn $scope,
      errors: new Array()
      headings: new Array()
      mappers: new Array()

      hasRequiredHeadings: ->
        HeaderRowCompatibilityService.hasRequiredHeadings($scope.headings)

    # Build array of FieldMappers
    mappers = []

    mappers = _.map headerRow, (heading, i) ->
      heading = heading.trim()
      if heading.match /^#.*/
        FieldMapper("ignored")
      else
        normalizedHeading = HeaderRowCompatibilityService.normalizeHeading(heading)
        tagHeading = PartnerTagUploadService.normalizeRepeatableHeading(heading)
        if normalizedHeading
          if _.isArray(normalizedHeading)
            $scope.headings.push normalizedHeading[0]
            FieldMapper.apply(this, normalizedHeading)
          else
            $scope.headings.push normalizedHeading
            FieldMapper(normalizedHeading)
        else if tagHeading
          FieldMapper.apply(this, tagHeading)
        else
          $scope.errors.push "Invalid heading for column " + (i + 1) + ": '" + heading + "'"
          FieldMapper("ignored")

    $scope.mappers = _.zipObject(headerRow, mappers)


    # TODO: maybe this check should live higher up?
    unless $scope.hasRequiredHeadings()
      $scope.errors.push "At least one of Text, Image, or Sound is required for both Anchor and Association"

    $scope
])
